import { TableRow, TableCell } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { ALL_NS } from '~/i18n/namespaces'
import { EFOtapAgentNetworkSchedulesCell } from './EFOtapAgentNetworkSchedulesCell'
import { DaySchedules } from './EFOtapAgentNetworkSchedules.model'

export function EFOtapAgentNetworkSchedulesRow(
  {
    day,
    maxScheduleHoursLength,
    methods,
    formPath,
    maxConcurrentTypeInfo
  }: Readonly<DaySchedules>
)
{
  const { t } = useTranslation(ALL_NS)
  const { register, getValues, setValue } = methods;
  const dayHours = Array.from(getValues(formPath) ?? '');

  const validateSchedules = {
    required: t('Message_RequiredField'),
    minLength: {
      value: maxScheduleHoursLength,
      message: t('Message_OtapAgentNetwork_InvalidHoursSchedule')
    },
    maxLength: {
      value: 1,
      message: t('Message_OtapAgentNetwork_InvalidHoursSchedule')
    }
  }

  const onChange = (index: number, newValue: string) => {
    const currentHourChars = getValues(formPath);
    const updatedHourChars = currentHourChars.substring(0, index) + newValue + currentHourChars.substring(index + 1);
    setValue(formPath, updatedHourChars, {
      shouldDirty: true,
    });
  }

  register(formPath, validateSchedules)

  return (
    <TableRow>
      <TableCell>
        { day }
      </TableCell>
      {
        dayHours.map((maxConcurrentType: any, index: number) => (
        <EFOtapAgentNetworkSchedulesCell 
          key={ `${day}_${index}` }
          day={ day }
          hour={ index }
          concurrentType={ maxConcurrentType }
          handler={onChange}
          maxConcurrentTypeInfo={maxConcurrentTypeInfo}
        />
      ))}
    </TableRow>
  );
}